import { getCopy, logo } from 'bundles/coursera-plus/utils/courseraPlusUtils';
import type { ValueProp } from 'bundles/payments/common/types';

import cert from 'images/payments/cert.png';
import certificate from 'images/payments/certificate.png';
import compass from 'images/payments/compass.png';
import head from 'images/payments/head.png';
import money from 'images/payments/money.png';

import _t from 'i18n!nls/payments';

export const getConfirmationPageValueProps = ({ isLite }: { isLite: boolean }): Array<ValueProp> => {
  const { numberOfProducts, numberOfProductsInCourseraLite } = getCopy();
  const secondProp = {
    id: 'switch_courses',
    title: _t('Flexible learning'),
    primaryImageUrl: head,
    description: _t('Learn at your own pace, move between multiple courses, or switch to a different course'),
    imageHeight: 55,
  };

  return isLite
    ? [
        {
          id: 'look_for_lite',
          title: _t('Look for the LITE'),
          primaryImageUrl: logo.LITE_PILL_BLUE,
          description: _t(
            'Enroll in any of the #{numberOfProducts} courses, Specializations, or Professional Certificates marked with the Coursera Lite badge',
            { numberOfProducts: numberOfProductsInCourseraLite }
          ),
          imageHeight: 37,
        },
        secondProp,
      ]
    : [
        {
          id: 'look_for_plus',
          title: _t('Look for the PLUS'),
          primaryImageUrl: logo.PLUS_PILL_BLUE,
          description: _t(
            'Enroll in any of the #{numberOfProducts} courses, Projects, Specializations, or Professional Certificates marked with the Coursera Plus badge',
            { numberOfProducts }
          ),
          imageHeight: 37,
        },
        secondProp,
        {
          id: 'unlimited_certificates',
          title: _t('Unlimited certificates'),
          primaryImageUrl: cert,
          description: _t(
            'Earn a certificate for every learning program that you complete after your trial ends at no additional cost'
          ),
          imageHeight: 40,
        },
      ];
};

export const getCourseraLiteValueProps = (): Array<ValueProp> => {
  return [
    {
      id: 'learn_skills',
      title: _t('Learn skills'),
      description: _t('Explore your interests and trending topics'),
      primaryImageUrl: compass,
      imageHeight: 55,
    },
    {
      id: 'save_money',
      title: _t('Save money'),
      description: _t('Spend less to take multiple courses and learn skills'),
      primaryImageUrl: money,
      imageHeight: 47,
    },
    {
      id: 'flexible_learning',
      title: _t('Flexible learning'),
      description: _t('Learn at your own pace and easily switch courses'),
      primaryImageUrl: head,
      imageHeight: 55,
    },
  ];
};

export const getDescriptionPageValueProps = ({
  isCourseraLiteContentfulPage,
}: {
  isCourseraLiteContentfulPage?: boolean;
} = {}): Array<ValueProp> => {
  if (isCourseraLiteContentfulPage) {
    return getCourseraLiteValueProps();
  }

  return [
    {
      id: 'learn_anything',
      title: _t('Learn anything'),
      description: _t('Explore any interest or trending topic, take prerequisites, and advance your skills'),
      primaryImageUrl: compass,
      imageHeight: 55,
    },
    {
      id: 'save_money',
      title: _t('Save money'),
      description: _t('Spend less money on your learning if you plan to take multiple courses this year'),
      primaryImageUrl: money,
      imageHeight: 47,
    },
    {
      id: 'flexible_learning',
      title: _t('Flexible learning'),
      description: _t('Learn at your own pace, move between multiple courses, or switch to a different course'),
      primaryImageUrl: head,
      imageHeight: 55,
    },
    {
      id: 'unlimited_certificates',
      title: _t('Unlimited certificates'),
      description: _t(
        'Earn a certificate for every learning program that you complete after your trial ends at no additional cost'
      ),
      primaryImageUrl: certificate,
      imageHeight: 40,
    },
  ];
};
